import './BlogPosts.css';
import React from "react";
import { useSelector } from 'react-redux';
import * as Utils from './Utils';
import Tags from './Tags';

function BlogPosts() {
    const blogs = useSelector((state) => state.counter.blogs);
    let sortedBlogs = blogs.sort((a, b) => new Date(b.postDate) - new Date(a.postDate));
    
    return (
        <section className="content">
            <div className="posts-block">
                <section className="tags-content">
                    <div className="header-tags"><b>Topics</b></div>
                    <div className="tags-blox">
                        <Tags />
                    </div>
                </section>
                <section className="bloglist-content">
                    <div className="bloglist-tags"><b>Blog Posts</b></div>
                    <div className="blog-items">
                        {sortedBlogs.map(function(d, idx){
                            return (
                                <div className="blog-item" key={idx}>
                                    <div className="blog-title">
                                    <a className="blog-item-link" href={d.link}>
                                    {d.name}
                                    </a>
                                    </div>
                                    <div className="blog-date">
                                        {Utils.formatedDate(d.postDate)}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </section>
            </div>
        </section>
    )
}

export default BlogPosts;